import { useContext } from "react";
import { NoContextError } from "@fileManagement/shared/exceptions/NoContextError";
import { MonitoringContext } from "@fileManagement/shared/contexts/MonitoringProvider";
import type Monitoring from "@core/shared/services/monitoring/Monitoring";

export const useMonitoring = (): Monitoring => {
  const monitoring = useContext(MonitoringContext);

  if (!monitoring) {
    throw new NoContextError("MonitoringContext");
  }

  return monitoring;
};
